import trainingCategoryAPI from "@/api/master-data/training-category/training-category";

export default {
  namespaced: true,
  
  state: {
    trainingCategories: [],
    totalItems: 0,
    loading: false,
    error: null
  },

  getters: {
    getTrainingCategories: (state) => state.trainingCategories,
    getTotalItems: (state) => state.totalItems,
    getLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    
    SET_TRAINING_CATEGORIES(state, data) {
      // Handle different response structures
      state.trainingCategories = data.data.data;
      state.totalItems = data.data.data.total || data.data.data.length;
    },
    
    SET_ERROR(state, error) {
      state.error = error;
    },
    
    CLEAR_ERROR(state) {
      state.error = null;
    },

    ADD_TRAINING_CATEGORY(state, trainingCategory) {
      // Handle different response structures
      const newItem = trainingCategory.data || trainingCategory;
      state.trainingCategories.unshift(newItem);
      state.totalItems += 1;
    },

    UPDATE_TRAINING_CATEGORY(state, updatedTrainingCategory) {
      // Handle different response structures
      const updatedItem = updatedTrainingCategory.data || updatedTrainingCategory;
      const index = state.trainingCategories.findIndex(
        item => item.id === updatedItem.id
      );
      if (index !== -1) {
        state.trainingCategories.splice(index, 1, updatedItem);
      }
    },

    REMOVE_TRAINING_CATEGORY(state, id) {
      const index = state.trainingCategories.findIndex(item => item.id === id);
      if (index !== -1) {
        state.trainingCategories.splice(index, 1);
        state.totalItems -= 1;
      }
    }
  },

  actions: {
    async getTrainingCategories({ commit }, params) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      
      try {
        const response = await trainingCategoryAPI.getTrainingCategories(params);
        commit('SET_TRAINING_CATEGORIES', response.data);
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to fetch training categories';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async getTrainingCategory({ commit }, id) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      
      try {
        const response = await trainingCategoryAPI.getTrainingCategory(id);
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to fetch training category';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createTrainingCategory({ commit }, data) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      
      try {
        const response = await trainingCategoryAPI.createTrainingCategory(data);
        // Don't add to store here, let the UI refresh the list
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to create training category';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async updateTrainingCategory({ commit }, { id, data }) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      
      try {
        const response = await trainingCategoryAPI.updateTrainingCategory(id, data);
        // Don't update store here, let the UI refresh the list
        return response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to update training category';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async deleteTrainingCategory({ commit }, id) {
      commit('SET_LOADING', true);
      commit('CLEAR_ERROR');
      
      try {
        await trainingCategoryAPI.deleteTrainingCategory(id);
        commit('REMOVE_TRAINING_CATEGORY', id);
        return { success: true };
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to delete training category';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  }
};